<template>
  <div id="printable" class="content-wrapper">
    <section class="history plan-history">
      <h1>{{ $t("plan.planHistory.header") }}</h1>
      <h2 class="report-topic">Plan: <strong>{{ plan.name }}</strong></h2>
    </section>
    <CreditHistory
      v-if="this.historyData.length > 0"
      v-bind:historyData="this.historyData"
    />
  </div>
</template>

<script>
import CreditHistory from '@/components/CreditHistory.vue'

import { planService } from '@/services/plan.service'

export default {
  name: 'PlanHistory',
  components: {
    CreditHistory
  },
  data: function () {
    return {
      plan: {},
      historyData: []
    }
  },
  created: function () {
    this.fetchData()
    this.fetchPlan()
  },
  methods: {
    fetchPlan: function () {
      // grab the plan
      planService.getPlan(this.$route.params.planId).then(plan => {
        this.plan = plan
      })
    },
    fetchData: function () {
      planService.meterEvents(this.$route.params.planId).then((data) => {
        this.historyData = data.reverse()
      })
    }
  }
}
</script>
